<template>
    <div class="card p-3 border-radius-xl bg-white" data-animation="FadeIn">
        <h5 class="font-weight-bolder mb-0">Assistência Técnica</h5>
        <p class="mb-0 text-sm">Caso já tenha recebido as chaves da sua unidade e precise de assistência técnica,
            preencha os campos abaixo</p>
        <div class="multisteps-form__content mt-4">
            <div class="row">
                <div class="col-12 col-sm-12">
                    <label>Descrição*</label>
                    <textarea v-model="form.message" rows="5" class="form-control"
                        placeholder="Descreva brevemente sua solicitação"></textarea>
                </div>
            </div>
            <div class="row mt-4">
                <label>Anexos</label>
                <div class="file-upload-wrapper">
                    <button class="file-upload-button" @click="triggerFileUpload">
                        <i class="fa fa-paperclip"></i> Anexar
                    </button>
                    <input class="file-upload-input" name="files[]" type="file" multiple @change="handleFileUpload"
                        ref="fileInput" />
                </div>
                <div class="mt-2">
                    <small style="font-size: 10px;">Arquivos permitidos: JPEG, JPG PNG.</small>
                </div>
                <div>
                    <small style="font-size: 10px;">Tamanho max.: 10MB por arquivo.</small>
                </div>
                <ul class="file-list px-2">
                    <li v-for="(file, index) in files" :key="index">
                        {{ file.name }}
                        <a href="#" @click.prevent="removeFile(index)" class="remove-file-btn" style="color: red;"><i class="fa fa-times" aria-hidden="true"></i></a>
                    </li>
                </ul>
            </div>
            <div class="button-row d-flex mt-2">
                <button @click.prevent="formValidation"
                    class="btn custom-btn bg-segment-primary-color ms-auto mb-0">Enviar <i v-if="loading"
                        class="fa fa-spinner fa-pulse fa-fw"></i></button>
            </div>
        </div>
    </div>
</template>

<script setup>
import axios from "axios";
import { ref, reactive, computed } from "vue";
import { useStore } from "vuex";
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { showToast } from "@/assets/js/toast.js";
import { SALESFORCE_DIVISIONS } from '@/assets/js/constants.js';

const store = useStore();

const contractData = computed(() => store.getters.getCurrentContract);

const loading = ref(false);

const form = reactive({
    subject: 'Assistencia Técnica',
    message: '',
    item: 'Assistencia Técnica',
    division_id: SALESFORCE_DIVISIONS.ASSISTENCIA_TECNICA,
    contract_id: parseInt(contractData.value.contrato_id),
    origin_id: ref(2)
});

const rules = {
    subject: { required },
    message: { required },
    division_id: { required },
    contract_id: { required },
};

const validate = useVuelidate(rules, form);

const files = ref([]);

const handleFileUpload = (event) => {
    const maxSize = 10 * 1024 * 1024; // 10MB em bytes
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];

    const selectedFiles = Array.from(event.target.files);
    let validFiles = [];

    for (let file of selectedFiles) {
        if (file.size > maxSize) {
            showToast("O arquivo " + file.name + " é maior que 10MB.", 'warning')
        } else if (!allowedTypes.includes(file.type)) {
            showToast("O arquivo " + file.name + " não é uma imagem permitida (JPEG, JPG PNG).", 'warning')
        } else {
            validFiles.push(file);
        }
    }

    files.value = validFiles;
};

const triggerFileUpload = () => {
    document.querySelector('.file-upload-input').click();
};

const removeFile = (index) => {
    files.value.splice(index, 1);
};

const formValidation = async () => {
    validate.value.$touch();
    if (validate.value.$invalid) {
        showToast('Campos obrigatórios não preenchidos.', 'error');
        return;
    }
    try {
        await createTechnicalAssistanceRequest();
    } catch (error) {
        console.error('Erro ao enviar solicitação de Assistência Técnica:', error);
        showToast('Erro ao enviar solicitação de Assistência Técnica', 'error');
    }
};

const createTechnicalAssistanceRequest = async () => {
    loading.value = true;
    const formData = new FormData();
    formData.append('subject', form.subject);
    formData.append('message', form.message);
    formData.append('item', form.item);
    formData.append('division_id', form.division_id);
    formData.append('contract_id', form.contract_id);
    formData.append('origin_id', 2);

    files.value.forEach(file => {
        formData.append('files[]', file);
    });

    try {
        const response = await axios.post('/contact/technicalassistance', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        if (response.data) {
            showToast('Solicitação de Assistência Técnica enviada com sucesso!', 'success');
        }
    } catch (error) {
        console.error('Erro ao enviar solicitação de Assistência Técnica:', error);
        showToast('Erro ao enviar solicitação de Assistência Técnica', 'error');
    } finally {
        loading.value = false;
    }
};
</script>

<style scoped>
.file-upload-wrapper {
    position: relative;
    overflow: hidden;
    display: inline-block;
}

.file-upload-button {
    background-color: #4F097B;
    border-radius: 40px;
    height: 1.875rem;
    border: 2px solid #4F097B;
    color: white;
    padding: 0 20px;
    cursor: pointer;
    display: inline-block;
}

.file-upload-input {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
    padding: 0;
    font-size: 100px;
    cursor: pointer;
    opacity: 0;
    filter: alpha(opacity=0);
}

.file-list {
    margin-top: 10px;
    list-style-type: none;
    padding: 0;
}

.file-list li {
    background-color: #f0f0f0;
    border: 1px solid #ddd;
    margin-top: 5px;
    padding: 5px;
    border-radius: 5px;
}
</style>
